import { StdResponse, request } from "@/global/config/request";
import { GlobalSensor, GlobalSensorParameter, MonixDeviceFunction } from "@/global/interface/lib-device/global-sensor";


export function getGlobalSensorDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalSensor(data: GlobalSensor, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-sensors`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalSensor(id: number, data: GlobalSensor, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-sensors/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalSensor(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalSensors(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-sensors`, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalSensorParameter(id: number, data: GlobalSensorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-sensor-parameters/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function createMonixDeviceFunction(id: number, data: MonixDeviceFunction, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-sensor/${id}/create-functions`, data, {
        params: {
            ...params,
        }
    })
}

export function updateMonixDeviceFunction(id: number, data: MonixDeviceFunction, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-sensor/${id}/update-functions`, data, {
        params: {
            ...params,
        }
    })
}